import { ThemeProperties } from '../../../core';
export interface InputSwitchTheme {
	labelColor: string; // coreTokens.color.content
	labelFont: string;
	labelCheckedFont: string;
	inputIconColor: string;
	inputBg: string;
	inputCheckedBg: string;
	inputCheckedHoverBg: string;
	inputCheckedActiveBg: string;
	inputHoverBg: string;
	inputActiveBg: string;
	inputFocus: string;
	thumbBg: string;
}

export const theme = new ThemeProperties('inputSwitch');
